import React, { useEffect } from 'react';
import {
    FlexBetween, SubHeading, TagChipsContainer, ThemeButton, TagChips,
    UploadContainer
} from "static/styled/custom.styled";
import { module as story } from "@st/story";
import { connectStore } from "redux-box";
import { module as onboard } from "@st/onboard";
import Permission from "@s/permission";

const SeriesSection = ({story, onboard}) => {

    useEffect(()=>{
        story.requestGetStorySeries(story.active_story.id)
    },[])

    const handleSeriesTag = (seriesId)=>{
        let data = {
            is_deleted : true,
            id : seriesId,
            story : story.active_story.id
        }
        story.requestUpdateStorySeries(data);
    }

    return (
        <UploadContainer>
            <FlexBetween>
                <SubHeading primary> Related Series</SubHeading>
                {Permission.getPermission(onboard.permission, "change_story") && story.story_series.length < 1?
                    <ThemeButton onClick={() => story.setStoryEditorType('series')}> + New series </ThemeButton>
                    : null}
            </FlexBetween>
            {story && story.story_series && story.story_series.length > 0 && <TagChipsContainer>
                {story.story_series.map((data, id) => (
                    <TagChips key={id} onClick={() => handleSeriesTag(data.id)}>{data.series.name}{ }
                        <img className="image-fluid" src={require("static/img/tagCloseIcon.png")} alt="Edit icon" />
                    </TagChips>
                ))}
            </TagChipsContainer>}
        </UploadContainer>
    )
}

export default connectStore({
    story, onboard
})(SeriesSection);